import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: '关于我们', href: '#about' },
  { label: '常见问答', href: '#faq' },
  { label: '主题索引', href: '#index' },
  { label: '联系投稿', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-sun-fill text-background-50 text-lg md:text-xl"></i>
            </div>
            <span className="text-lg md:text-xl font-bold font-heading text-foreground-900 whitespace-nowrap">
              向日葵视频
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50 cursor-pointer whitespace-nowrap"
            >
              首页
            </a>
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <nav className="flex flex-col px-4 py-3 gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                setMobileOpen(false);
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50 cursor-pointer"
            >
              首页
            </a>
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}